import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  TextField,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";
import axios from "axios";

// Define your API key here
const API_KEY = process.env.REACT_APP_API_KEY;

interface NewsletterModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const NewsletterModal: React.FC<NewsletterModalProps> = ({
  isOpen,
  onClose,
}) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://api.kit.com/v4/subscribers",
        {
          first_name: name,
          email_address: email,
          state: "active",
          fields: {
            phone_number: phone,
            source: "landing page",
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Kit-Api-Key": API_KEY,
          },
        }
      );

      if (response.status === 201 || response.status === 200) {
        setEmail("");
        setName("");
        setPhone("");
        onClose();
        Swal.fire({
          title: "Thank You!",
          text: "You have successfully subscribed to our newsletter!",
          icon: "success",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "Something went wrong, please try again!",
          icon: "error",
        });
        onClose();
      }
    } catch (error: any) {
      console.error("API Error:", error.response?.data || error.message);
    }
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          borderRadius: "0",
          p: 4,
          maxWidth: "360px",
          width: "90%",
          textAlign: "center",
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: "16px",
            right: "16px",
            color: "#707070",
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Newsletter Form */}
        <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1, textAlign: "left" }}>
          Newsletter
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, textAlign: "left" }}>
          Do not miss your chance to know more about our events and services.
          Subscribe now!
        </Typography>

        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
        >
          <TextField
            label="Name"
            variant="outlined"
            fullWidth
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            label="Email"
            type="email"
            variant="outlined"
            fullWidth
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Phone Number"
            type="tel"
            variant="outlined"
            fullWidth
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <Button
            type="submit"
            variant="contained"
            sx={{ bgcolor: "#FFD215", color: "black" }}
          >
            Subscribe
          </Button>
          <Typography variant="body1" sx={{ mb: 2, fontSize: "0.7rem" }}>
            We respect your privacy. You can unsubscribe at any time.
          </Typography>
        </form>
      </Box>
    </Modal>
  );
};

export default NewsletterModal;
